<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="rgba(var(--foreground))"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0.459961C5.40266 0.459961 0.459961 5.40266 0.459961 11.5C0.459961 17.5973 5.40266 22.54 11.5 22.54C17.5973 22.54 22.54 17.5973 22.54 11.5C22.54 5.40266 17.5973 0.459961 11.5 0.459961ZM8.79746 16.0758H6.56186V8.88141H8.79746V16.0758ZM7.66586 7.99821C6.95976 7.99821 6.50321 7.49796 6.50321 6.87926C6.50321 6.24791 6.97356 5.76261 7.69461 5.76261C8.41566 5.76261 8.85726 6.24791 8.87106 6.87926C8.87106 7.49796 8.41566 7.99821 7.66586 7.99821ZM16.9625 16.0758H14.7269V12.0888C14.7269 11.1607 14.4026 10.5305 13.5941 10.5305C12.9766 10.5305 12.6097 10.9572 12.4476 11.3677C12.3878 11.5138 12.3728 11.7208 12.3728 11.9266V16.0747H10.1361V11.1757C10.1361 10.2775 10.1073 9.52656 10.0774 8.88026H12.0198L12.1221 9.87961H12.167C12.4614 9.41041 13.1824 8.71811 14.3888 8.71811C15.8596 8.71811 16.9625 9.70366 16.9625 11.822V16.0758Z"
      fill="foreground"
    />
  </svg>
</template>
